// ----------------- [ A4D Settings :: ACTIONS ] ----------------- //

import {BOOL, NUMBER, PATH, PROP, TRUE_UNLESS_0, VALUE} from "../../types";
import {helpers_url} from "@helpers/helpers_url";
import Cookies from "js-cookie";
import {PARA__SHIPPING_INCL, PARA__TEST_MODE, PARA__VAT_INCL} from "./types";
import {get} from "lodash-es";
import {a4d_castHelpers} from "@helpers/a4d_castHelpers";

export const actions = {

    /**
     * Actions to execute on initialization / page load
     * @param commit
     * @param dispatch
     * @param {Object} settings
     * @constructor
     */
    'INIT' : ({dispatch, state}, settings) =>
    {
        // settings passed from controller
        if (settings)
            dispatch('SET_SETTINGS', settings);

        // process settings from cookie
        dispatch('merge_settings_from_cookie');

        // process settings from url parameters
        dispatch('PROCESS_URL_PARAMETERS');
        // dispatch('update_cookie');
    },


    /**
     * Update settings with values from cookie
     * @param state
     * @param commit
     */
    'merge_settings_from_cookie' : ({state, commit}) =>
    {
        let cookie_settings = Cookies.get('settings');
        if (!cookie_settings)
            return;

        cookie_settings = JSON.parse( Cookies.get('settings') );
        for (const [key,value] of Object.entries(cookie_settings)) {
            if (state.settings_map.hasOwnProperty(key))
                commit('UPDATE_PROPERTY', {
                [PATH]  : state.settings_map[key],
                [VALUE] : value
            });
        }
    },


    /**
     *
     * @param commit
     * @param state
     * @param {Object} settings
     */
    'SET_SETTINGS' : ({commit, state}, settings) =>
    {
        for ( const [key, value] of Object.entries(settings)) {
            if (state[key] === value)
                continue;
            commit('SET_PROPERTY_OBJECT', {
                obj     : state,
                [PROP]  : key,
                [VALUE] : value
            });
        }
    },


    /**
     * Process parameters from url
     * Only process given parameters
     * @param dispatch
     * @param state
     * @constructor
     */
    'PROCESS_URL_PARAMETERS' : ({dispatch, state}) =>
    {
        let parameters = helpers_url.get_parameters();

        dispatch('PROCESS_URL_PARAMETER', {
            parameters      : parameters,
            parameter       : PARA__TEST_MODE,
            [PROP]          : state.settings_map[PARA__TEST_MODE],
            type            : TRUE_UNLESS_0,
            default_value   : 0, // always disable test mode by default
            skip_update_cookie : true
        });

        dispatch('PROCESS_URL_PARAMETER', {
            parameters      : parameters,
            parameter       : PARA__SHIPPING_INCL,
            [PROP]          : state.settings_map[PARA__SHIPPING_INCL],
            type            : TRUE_UNLESS_0,
            skip_update_cookie : true
        });

        dispatch('PROCESS_URL_PARAMETER', {
            parameters      : parameters,
            parameter       : PARA__VAT_INCL,
            [PROP]          : state.settings_map[PARA__VAT_INCL],
            type            : TRUE_UNLESS_0,
            skip_update_cookie : true
        });

        dispatch('update_cookie');
    },

    /**
     * Process query parameter form url
     * Using default function instead of arrow function to be able to check if parameter was passed
     * arguments is a special keyword in traditional JavaScript functions but is not available in arrow functions.
     * @param dispatch
     * @param parameters
     * @param {string} parameter
     * @param {string} prop
     * @param {string} type
     * @param {Object} target_object
     * @param default_value
     * @param {boolean} skip_update_cookie
     * @constructor
     */
    'PROCESS_URL_PARAMETER' : function({dispatch}, {
        parameters,
        parameter,
        prop,
        type,
        target_object,
        default_value,
        skip_update_cookie
    }) {
        // get url query parameters if missing
        parameters = parameters ?? helpers_url.get_parameters();

        // return if parameter was not set in url AND no default value was given
        if (!parameters.has(parameter) && !('default_value' in arguments[1]))
            return false;

        let value = parameters.get(parameter) ?? default_value;

        dispatch('UPDATE_SETTING', {
            prop,
            type,
            value,
            skip_update_cookie
        });
        return true;
    },


    /**
     * @param commit
     * @param dispatch
     * @param state
     * @param path
     * @param prop
     * @param value
     * @param {string} type
     * @param {boolean} skip_update_cookie
     * @constructor
     */
    'UPDATE_SETTING' : ({commit, dispatch, state}, {path, prop, value, type, skip_update_cookie}) =>
    {
        // console.log('UPDATE_SETTING', path, prop, value, skip_update_cookie);
        path = path ?? prop;

        // optionally cast property type
        switch(type) {
            case BOOL :
                value = a4d_castHelpers.BOOL(value);
                break;
            case NUMBER :
                value = a4d_castHelpers.NUMBER(value);
                break;
            case TRUE_UNLESS_0 :
                value = (String(value) !== '0'); // only value of 0 defaults to false
                break;
        }

        // return if nothing changed
        let old_value = get(state, path, undefined);
        if (value === old_value)
            return false;

        // set value - state.<path> MUST exist for reactivity
        commit('UPDATE_PROPERTY', {
            [PATH]  : path,
            [VALUE] : value
        });


        // update cookie - true by default
        if (!skip_update_cookie)
            dispatch('update_cookie');

        return true;
    },


    /**
     * Save user based settings and preferences
     * @param state
     */
    'update_cookie' : ({state}) => {
        let data = {
            [PARA__SHIPPING_INCL]   : state.price.total_incl_shipping,
            [PARA__TEST_MODE]       : state.test_mode,
            [PARA__VAT_INCL]        : state.vat.included
        }
        // console.log('update cookie settings: ', data);
        Cookies.set('settings', JSON.stringify(data), {
            expires : 365,
            sameSite: 'Lax',  // Allows the cookie in first-party contexts
            secure  : window.location.protocol === 'https:' // Only set 'Secure' if on HTTPS
        });
    },
};
